import { BucketIdentifier, S3File } from "@dune/types";
import { UploadFileByButton } from "@dune/ui";
import { usePostFileOnAWSS3 } from "../../api/mutations/files.mutations";
import {
	useGetSignedGetUrlQuery,
	useGetSignedPutUrlQuery,
} from "../../api/queries/files.queries";

type S3FileInputProps = {
	bucket: BucketIdentifier;
	onUploadSuccess: (s3File: S3File) => void;
};

export const S3ButtonInput = ({
	bucket,
	onUploadSuccess,
}: S3FileInputProps) => {
	const {
		data: signedPutUrlData,
		isLoading: isLoadingPutUrl,
		refetch: refetchPutUrl,
	} = useGetSignedPutUrlQuery(bucket);
	const { refetch: refetchGetUrl } = useGetSignedGetUrlQuery(
		signedPutUrlData?.key || "",
	);
	const { mutateAsync: postFileOnAwsS3 } = usePostFileOnAWSS3();

	const handleFileChange = async (file: File | null) => {
		if (!file || isLoadingPutUrl) return;

		const { data: signedPut } = await refetchPutUrl();

		if (!signedPut?.signedUrl || !signedPut?.key) return;
		await postFileOnAwsS3({ file, url: signedPut.signedUrl });

		const { data: signedGet } = await refetchGetUrl();

		const s3File: S3File = {
			bucket,
			key: signedPut.key,
			type: file.type,
			size: file.size,
			name: file.name,
			url: signedGet || "",
		};

		onUploadSuccess(s3File);
	};

	return <UploadFileByButton onFileChange={handleFileChange} />;
};
